// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"2b41e549","483":"e3487f31"}[chunkId] + ".chunk.js";
};